import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// libraries
import $ from 'jquery';

// material UI
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import * as CONFIG from '../config';
import * as UTILS from '../utils/utilFunctions';
import TEXT from '../text';

function isISODateString(value) {
  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  if (isoRegex.test(value)) return true;

  const dateRegex = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4}/;
  if (dateRegex.test(value)) return true;

  return false;
}

function getFieldLabel(key, obj) {
  return key
    .split('.')
    .filter(part => part !== '$')
    .reduce((current, part) => (current && current[part] ? current[part] : key), obj);
}

function isHTML(string) {
  return /<\/?[a-z][\s\S]*>/i.test(string);
}

function extractTextFromHTML(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent || div.innerText || '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

class HistoryDrawer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { changeHistory: [] };
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  transition(props) {
    return <Slide direction="up" mountOnEnter unmountOnExit {...props} />;
  }

  loadHistory() {
    const url = this.props.url;
    const requestBody = this.props.payload;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'x-auth': tokenFromLocalStorage },
      data: JSON.stringify(requestBody),
      timeout: CONFIG.ajaxTimeout
    })
      .done(responseBody => {
        this.setState({ changeHistory: responseBody });
      })
      .fail(err => {
        this.errorHandling(err, url);
      });
  }

  componentDidMount() {
    this.loadHistory();
  }

  renderHistorylist() {
    const array = [];
    this.state.changeHistory.forEach(async change => {
      const changeDate = new Date(change.changeDate);
      const fieldKey = change.changedField;

      const fieldLabel = getFieldLabel(fieldKey, TEXT.changeHistory.fields);
      let oldValueText;
      const dateOld = new Date(change.oldValue);
      if (change.oldValue === 'true') {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${TEXT.changeHistory.yes}`;
      } else if (change.oldValue === 'false') {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${TEXT.changeHistory.no}`;
      } else if (change.oldValue === 'available') {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${TEXT.changeHistory.available}`;
      } else if (change.oldValue === 'locked') {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${TEXT.changeHistory.locked}`;
      } else if (isISODateString(change.oldValue)) {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${dateOld.toLocaleDateString('de-DE')}`;
      } else if (isHTML(change.oldValue)) {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${extractTextFromHTML(change.oldValue)}`;
      } else if (change.oldValue === '') {
        oldValueText = `Neuer Eintrag erstellt (${fieldLabel})`;
      } else {
        oldValueText = `Vorheriger Wert (${fieldLabel}): ${change.oldValue}`;
      }

      let newValue = change.newValue;
      let newValueText = '';
      const dateNew = new Date(change.newValue);

      if (isHTML(newValue)) {
        newValue = extractTextFromHTML(newValue);
      }

      if (newValue === 'true') {
        newValueText = 'Ja';
      } else if (newValue === 'false') {
        newValueText = 'Nein';
      } else if (newValue === 'available') {
        newValueText = 'verfügbar';
      } else if (newValue === 'locked') {
        newValueText = 'gesperrt';
      } else if (isISODateString(newValue)) {
        newValueText = `Neuer Wert: ${dateNew.toLocaleDateString('de-DE')}`;
      } else {
        newValueText = newValue;
      }

      if (newValueText.length > 100) {
        if (window.screen.width < 1920) {
          newValueText = `${newValueText.substring(0, 30)}...`;
        }
        newValueText = `${newValueText.substring(0, 60)}...`;
      }

      const fieldName = `Feld: ${fieldLabel}`;
      array.push(
        <ListItem divider>
          <i className="material-icons">change_history</i>
          <ListItemText
            inset
            primary={fieldName}
            secondary={`${changeDate.toLocaleString()} von ${change.user.name} (${change.user.email})`}
            style={{ maxWidth: `${window.screen.width < 1920 ? '600px' : '800px'}`, paddingLeft: '16px' }}
          />
          <i className="material-icons pr-3">update</i>
          <ListItemText primary={`${newValueText}`} secondary={`${oldValueText}`} />
        </ListItem>
      );
    });
    return array;
  }

  render() {
    return (
      <Dialog fullScreen open={this.props.open} onClose={this.props.handleClose} TransitionComponent={this.transition}>
        <AppBar style={{ position: 'relative' }}>
          <Toolbar>
            <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" color="inherit">
              {TEXT.changeHistory.title}
            </Typography>
          </Toolbar>
        </AppBar>
        <List>{this.renderHistorylist()}</List>
      </Dialog>
    );
  }
}

HistoryDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,

  url: PropTypes.string.isRequired,
  payload: PropTypes.object.isRequired
};

export default HistoryDrawer;
